import { UserPreferencesState } from './user-preferences.models';
import { Action, createReducer, on } from '@ngrx/store';
import * as UserPreferencesActions from './user-preferences.actions';
import { Currencies } from '@cpak/enums';
import { AttributeTypeIds } from '@cpak/adp-cpak-products-service-models';

export const USER_PREFERENCES_KEY = 'user-preferences';

export interface UserPreferencesPartialState {
  readonly [USER_PREFERENCES_KEY]: UserPreferencesState;
}

export const initialUserPreferencesStateConfig: UserPreferencesState = {
  language: '',
  timeZone: '',
  currency: Currencies.local,
  partNumberDisplay: AttributeTypeIds.CatalogNumber,
  packDescriptionDisplay: null,
  showInternalNotes: false,
  showSpecialInstructions: true,
  receiveEmailNotifications: true,
  plant: undefined,
};

const reducer = createReducer(
  initialUserPreferencesStateConfig,
  on(UserPreferencesActions.setLanguage, (state, { language }) => ({
    ...state,
    language,
  })),
  on(UserPreferencesActions.setTimeZone, (state, { timeZone }) => ({
    ...state,
    timeZone,
  })),
  on(UserPreferencesActions.setCurrency, (state, { currency }) => ({
    ...state,
    currency,
  })),
  on(UserPreferencesActions.setPartNumberDisplay, (state, { partNumberDisplay }) => ({
    ...state,
    partNumberDisplay,
  })),
  on(UserPreferencesActions.setPackDescriptionDisplay, (state, { packDescriptionDisplay }) => ({
    ...state,
    packDescriptionDisplay,
  })),
  on(UserPreferencesActions.setShowInternalNotes, (state, { showInternalNotes }) => ({
    ...state,
    showInternalNotes,
  })),
  on(UserPreferencesActions.setShowSpecialInstructions, (state, { showSpecialInstructions }) => ({
    ...state,
    showSpecialInstructions,
  })),
  on(UserPreferencesActions.setReceiveEmailNotifications, (state, { receiveEmailNotifications }) => ({
    ...state,
    receiveEmailNotifications,
  })),
  on(UserPreferencesActions.setDefaultConfig, (state, userPreferences) => ({
    ...initialUserPreferencesStateConfig,
    ...userPreferences,
  })),
  on(UserPreferencesActions.setPlant, (state, { plant }) => ({
    ...state,
    plant,
  }))
);

export function userPreferencesReducer(state: UserPreferencesState | undefined, action: Action): UserPreferencesState {
  return reducer(state, action);
}
